export default "__VITE_ASSET__CaqS2PDs__"